// Which product features each subscription tier unlocks. There is no
// entitlements API yet, so this map is the single client-side source of
// truth — confirm the mapping with product before shipping.

import type { SubscriptionStatus } from '@/types';

export type Feature =
  | 'recurring_jobs'
  | 'payroll'
  | 'employees'
  | 'calendar_feed'
  | 'stripe_payments';

export const FEATURES_BY_TIER_SLUG: Record<string, Feature[]> = {
  solo: [],
  team: ['recurring_jobs', 'payroll', 'employees', 'calendar_feed', 'stripe_payments'],
  pro: ['recurring_jobs', 'payroll', 'employees', 'calendar_feed', 'stripe_payments'],
};

export function tierHasFeature(
  tierSlug: string | undefined,
  feature: Feature,
): boolean {
  if (!tierSlug) return false;
  return (FEATURES_BY_TIER_SLUG[tierSlug] ?? []).includes(feature);
}

/**
 * Whether a business's subscription lifecycle currently grants access to
 * paid features, independent of tier. `past_due` still has access (grace
 * period); `canceled` — or a `trialing` business whose trial has lapsed —
 * does not.
 */
export function hasActiveAccess(
  status: SubscriptionStatus,
  trialEndsAt: string | null,
): boolean {
  if (status === 'active' || status === 'past_due') return true;
  if (status === 'trialing') return !!trialEndsAt && new Date(trialEndsAt) > new Date();
  return false;
}
